import { render, staticRenderFns } from "./ActivateCode.vue?vue&type=template&id=68cc9eaa&scoped=true&"
import script from "./ActivateCode.vue?vue&type=script&lang=js&"
export * from "./ActivateCode.vue?vue&type=script&lang=js&"
import style0 from "./ActivateCode.vue?vue&type=style&index=0&id=68cc9eaa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68cc9eaa",
  null
  
)

export default component.exports